<button mat-raised-button (click)="generatePDF()">Generate PDF</button>
&nbsp;
<button mat-raised-button (click)="submitApplication()">Submit Application</button>
